"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CronSchedule = exports.cronRegexp = void 0;
const tslib_1 = require("tslib");
const cron_parser_1 = tslib_1.__importDefault(require("cron-parser"));
const uuid_1 = require("uuid");
const selectedConfig_1 = require("../../../selectedConfig");
const lambda_1 = require("../../lambda");
const debug = lambda_1.DEBUG_OVERRIDE || (lambda_1.NOT_LAMBDA && true);
exports.cronRegexp = /^(@(annually|yearly|monthly|weekly|daily|hourly|reboot|every\s+\d+(ns|us|µs|ms|s|m|h)+))$|^([\w*/,-]+)\s+([\w*/,-]+)\s+([\w*/,-]+)\s+([\w*/,-]+)\s+([\w*/,-]+)$/;
class CronSchedule {
    constructor({ cronStr, id }) {
        // 2025 09 changed default to false as now being used in Redis HotCold delayed persist
        this.disallowAllAny = false;
        this.cronStrMinsHoursAreAny = (s) => {
            const cronArr = s.split(' ');
            const isAllAny = cronArr.slice(0, 2).some((x) => x === '*');
            return isAllAny;
        };
        this.nextOccurenceUTC = (timestamp) => {
            const interval = cron_parser_1.default.parse(this.cronStr, { tz: 'UTC', currentDate: timestamp ? new Date(timestamp).toUTCString() : new Date().toUTCString() });
            return interval.next().toDate().valueOf();
        };
        this.getOccurances = (fromMs, toMs, tz) => {
            const options = {
                currentDate: new Date(fromMs).toUTCString(),
                endDate: new Date(toMs).toUTCString(),
                iterator: true,
                tz: tz ?? selectedConfig_1.defaultTZ,
            };
            const res = [];
            if (this.cronStr) {
                if (!this.disallowAllAny || !this.cronStrMinsHoursAreAny(this.cronStr)) {
                    const interval = cron_parser_1.default.parse(this.cronStr, options);
                    while (interval.hasNext()) {
                        try {
                            const tick = interval.next(); // typing give CronDate | IteratorResult<CronDate, CronDate>
                            res.push(tick.toDate().valueOf());
                        }
                        catch (e) {
                            console.log('Err in cron interval', e.message);
                            throw e;
                        }
                    }
                    debug && console.log(`no more next() with ${this.cronStr} between ${options.currentDate} and ${options.endDate} in tz ${options.tz}`);
                }
                else {
                    debug && console.log('Disallowed all any with', this.cronStr);
                }
            }
            else {
                console.log('WARN no cron string');
            }
            return res;
        };
        if (exports.cronRegexp.test(cronStr)) {
            this.cronStr = cronStr;
            this.id = id ?? (0, uuid_1.v4)();
        }
        else {
            throw new Error(`invalid cron string: ${cronStr}`);
        }
    }
}
exports.CronSchedule = CronSchedule;
